import { memo } from "react";
import VerifyEmailStep from "@/components/intake/VerifyEmailStep";
import type { IntakeData } from "@/lib/types";
import type { CardDef } from "../types";
import { useIntakeMobileChromeRegistration } from "../IntakeMobileChromeContext";

interface VerificationCardProps {
  card: CardDef;
  data: IntakeData;
  onUpdate: (data: Partial<IntakeData>) => void;
  onSuccess: () => void;
  onBack: () => void;
  formUid?: string;
  referenceUid?: string;
  /** Continuation route: hides the patient's email behind neutral copy. */
  maskedDestination?: string;
  /** Continuation route: overrides the send/verify calls. */
  sendCode?: () => Promise<{ challengeId?: string } | void>;
  verifyCode?: (code: string) => Promise<void>;
}

// Intake v2: dedicated OTP step (own card), then thank-you on success.
export const VerificationCard = memo(function VerificationCard({
  card,
  data,
  onUpdate,
  onSuccess,
  onBack,
  formUid,
  referenceUid,
  maskedDestination,
  sendCode,
  verifyCode,
}: VerificationCardProps) {
  useIntakeMobileChromeRegistration(
    () => ({ onCancel: onBack, showContinue: false }),
    [onBack],
  );

  return (
    <div className="w-full max-w-3xl">
      <VerifyEmailStep
        data={data}
        onUpdate={onUpdate}
        onVerificationSuccess={onSuccess}
        onBack={onBack}
        formUid={formUid}
        referenceUid={referenceUid}
        embeddedInFlow
        otpOnly
        stepQuestion={card.question}
        stepHint={card.hint}
        maskedDestination={maskedDestination}
        sendCode={sendCode}
        verifyCode={verifyCode}
      />
    </div>
  );
});
